<template>
  <div class="row">
    <div class="col-12">
      <span v-for="(item, i) of data" :key="i" class="m-2">
        <Tooltip :text="item.label" class="float-right" width="90px">
          <template v-if="item.id != 'reload'">
            <img :src="icon(item.icon)" alt="" srcset="">

            <span class="ml-2">

              {{ item.value }}
              <span v-if="item.value && item.symbol" class="ml-1">
                {{ item.symbol }}
              </span>

            </span>
          </template>
          <template v-else>
            <i @click="getData()" class="m-0 p-0 icon-refresh cursor-pointer"></i>
          </template>
        </Tooltip>
      </span>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from "vuex";
import { usersService } from "@/_services";
import Tooltip from "@/components/Common/Tooltip.vue";

export default {
  components: {
    Tooltip
  },
  data() {
    return {
      data: [
        {
          id: 'verified_tasks',
          label: "Verified tasks",
          icon: "checklist.png",
          color: "text-primary",
          value: null,
          symbol: '',
        },
        {
          id: 'meetings_booked',
          label: "Meeting booked",
          icon: "check-mark.png",
          color: "text-primary",
          value: null,
          symbol: '',
        },
        {
          id: 'meetings_rate',
          label: "Meetings rate",
          icon: "discount.png",
          color: "text-primary",
          value: null,
          symbol: '%',
        },
        {
          id: 'commission_per_meeting',
          label: "Commission / meeting booked",
          icon: "money-tag.png",
          color: "text-primary",
          value: null,
          symbol: '€',
        },
        {
          id: 'total_revenue',
          label: "Total revenue",
          icon: "money-tag.png",
          color: "text-primary",
          value: null,
          symbol: '€',
        },
        {
          id: 'reload',
          label: "",
          value: null
        },
      ]
    };
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user
    }),
    icon() {
      return fileName => {
        return require("@/assets/images/stats_bdr/" + fileName);
      };
    },

  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      this.data = this.data.map(el => {
        return {
          ...el,
          value: null
        }
      })
      usersService.getBookerStatsDailyTotals()
        .then((data) => {
          for (const key in data.result) {
            let xxx = this.data.find(el => el.id == key)
            if (xxx !== undefined) {
              xxx.value = data.result[key]
            }
          }
          this.$emit("setBdrInfo", data.result)
        })
        .catch((err) => console.log(err))
    },
  },
}
</script>